<script setup lang="ts">
import { LoginForm } from '~/components/auth/forms/';
import { LoginOrRegister } from '~/components/auth/labels/';
import { AppTypography } from '~/components/base/';
import LoginPage from '~/utils/contents/auth/pages/LoginPage';

definePageMeta({ layout: 'split', auth: false, middleware: 'guest' });

useHead({
  title: LoginPage.seo.title,
});
</script>

<template>
  <div class="login-page flex flex-col items-center justify-center text-center">
    <div class="login-page__header mb-5">
      <AppTypography type="title-4" element="h4" class="mb-2">{{
        LoginPage.title
      }}</AppTypography>
      <AppTypography type="body">{{ LoginPage.subtitle }}</AppTypography>
    </div>
    <LoginForm class="login-page__form mb-10" data-testid="login-form" />
    <div class="login-page__footer">
      <LoginOrRegister
        go-to="register"
        class="mb-10"
        data-testid="login-link"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
